import React from 'react';
import './IMATMeditaliaPlus.css'; // Make sure to create and link this CSS file
import backgroundImage from '../../assets/bgg.jpg'; // Adjust the path to your image


const IMATMeditaliaPremium = () => {
    const handleEnrollClick = () => {
        const phoneNumber = '+393508227323';
        const whatsappUrl = `https://wa.me/${phoneNumber}`;
        window.open(whatsappUrl, '_blank');
    };

    
    return (
        <div className="course-detail-container"
        style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        }}>
            <div className="course-description">
                <h5>IMAT Meditalia Premium Course
                    (€750) – 6 Months</h5>
                <p>Live Lectures (108 hours) [3 months] Starting March 2025</p>
                <ul>
                    <li>Access to simulation. (12)</li>
                    <li>Updated IMAT Material</li>
                    <li>Full guidance with personal interaction to improve scores</li>
                    <li>Bi-weekly mock tests with ranking</li>
                    <li>Access to online materials and career counseling</li>
                </ul>
                <button className="buy-button" onClick={handleEnrollClick}>Enroll Now</button>
            </div>

            {/* Right Section - Course Description */}
            <div className="course-description">
                <h2>About the Course</h2>
                <p>
                    This comprehensive 6-month course is designed to give students full support for their
                    IMAT preparation and university application process. It includes everything in the
                    Meditalia Prep & plus Course, along with additional services to help students smoothly
                    transition to studying medicine in Italy.
                </p>
                <h3>What’s Included?</h3>
                <ul>
                    <li>
                        <strong>IMAT Exam Registration</strong> –We will handle your IMAT exam registration, ensuring
                        you meet all deadlines and requirements.
                    </li>
                    <li>
                        <strong>Pre-Enrolment Assistance</strong> – Get guidance on pre-enrolling at Italian universities,
                        which is an important step before final admission.
                    </li>
                    <li>
                        <strong>Document Preparation</strong> – Assistance in gathering, organizing, and submitting all
                        required documents for university admission.
                    </li>
                    <li>
                        <strong>Live Lessons (108 Hours)</strong> – Attend interactive live lectures covering all IMAT
                        subjects, taught by experienced instructors.
                    </li>
                    <li>
                        <strong>University Selection Guidance</strong> – Receive expert advice on choosing the right
                        university based on your score, preferences, and future goals.
                    </li>

                    <li>
                        <strong>Scholarship Application Assistance</strong> – Learn about available scholarships and
                        receive help in preparing applications to secure financial aid.
                    </li>

                    <li>
                        <strong>Visa & Document Preparation</strong> – Complete guidance on student visa applications,
                        ensuring all necessary documents are correctly prepared for a smooth approval
                        process.
                    </li>
                    <li>
                        <strong>Personal Support –</strong> –Gain access to our dedicated team for any academic or
                        administrative concerns, making sure you stay on track throughout your IMAT
                        journey.
                    </li>
                </ul>
                <p>
                    This premium package is perfect for students looking for a complete solution for both
                    IMAT success and securing admission to Italian medical universities!
                </p>
            </div>
        </div>
    );
};

export default IMATMeditaliaPremium;
